export default "__VITE_ASSET__BT3y218O__"